import {
  DataCollectionFormField,
  StandardQuestionTemplate,
} from 'api-clients/monolith';

export type QuestionOption = {
  value: string;
  visible?: boolean;
  label?: string;
};

/**
 * One row of the editor. `uid` is the React key and drag id: a new question has
 * no server id yet, and an id-less row still has to be stable across renders.
 */
export type EditableQuestion = Omit<
  DataCollectionFormField,
  'options' | 'restricted' | '_destroy'
> & {
  uid: string;
  options: QuestionOption[] | null;
  restricted: boolean | null;
  _destroy?: boolean;
};

export type QuestionErrors = {
  question?: string;
  key?: string;
  options?: string;
};

export const OPTIONABLE_TYPES = ['radio', 'checkboxes', 'dropdown'];

export const CUSTOM_TYPES = [
  'text_field',
  'text_area',
  'radio',
  'checkboxes',
  'dropdown',
  'datepicker',
  'file',
  'address',
] as const;

export type CustomType = (typeof CUSTOM_TYPES)[number];

export const KEY_FORMAT = /^[a-z0-9_]+$/;

export const isOptionable = (type: string): boolean =>
  OPTIONABLE_TYPES.includes(type);

export const templateOptions = (
  template: StandardQuestionTemplate | undefined,
): QuestionOption[] =>
  (template?.options ?? []).map(option => ({
    value: String(option.value),
    label: option.label ?? undefined,
    visible: option.visible ?? true,
  }));
